// HorizontalBarChart.js
import { HorizontalBar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ['extraOptions'],
  mounted() {
    // Aplica las opciones extra pasadas al componente
    this.renderChart(this.chartData, { ...this.chartOptions, ...this.extraOptions });
  }
};
